<template>
  <div>
    <div
      class="job-box"
      @click="showDescriptionPageOnCardClick ? descriptionPage() : ''"
    >
      <div class="opportunity-icon-container">
        <slot name="jobBoxImg" />
      </div>

      <div
        @click="showDescriptionPage ? descriptionPage() : ''"
        class="opportunity-title-container"
      >
        <h1>
          <wheelchair-accessibility-icon v-if="opportunity.pcd" />
          {{ opportunity.title }}
        </h1>
      </div>

      <div class="opportunity-level-container">
        <h2>Nível {{ opportunity.level }}</h2>
      </div>

      <div
        class="opportunity-address-polo-description"
        v-if="opportunity.company_integration_fields.polo_description"
      >
        <h3>
          {{ opportunity.company_integration_fields.polo_description.toLowerCase() }}
        </h3>
      </div>

      <div
        v-if="!opportunity.company_integration_fields.polo_description"
        class="opportunity-address-container"
      >
        <slot name="mapMarkerIcon" class="opportunity-map-marker-icon" />

        <h3>
          <slot name="mapImg" />

          <span
            class="opportunity-address-acting-mode"
            v-if="opportunity.acting_mode"
          >
            {{ opportunity.acting_mode }}
          </span>
          
          <span class="opportunity-address-city" v-if="opportunity.address">
            {{ this.$helpers.toTitle(opportunity.address.city + " - ") }}
          </span>
          
          <span class="opportunity-address-state" v-if="opportunity.address && opportunity.address.state">
            {{ opportunity.address.state.abbr }}
          </span>
          
          <span 
            class="opportunity-address-distance"
            v-if="opportunity.geocode_distance &&
              (
                opportunity.geocode_distance.indexOf('metro') !== -1 ||
                opportunity.geocode_distance.indexOf('km') !== -1
              )
            "
          >
            {{ opportunity.geocode_distance }} de distância do CEP informado
            <br />
          </span>
          
          <span
            class="opportunity-address-street"
            v-if="opportunity.address && opportunity.address.street"
          >
            {{ opportunity.address.street.toLowerCase() + "," }}
          </span>

          <span
            class="opportunity-address-number"
            v-if="opportunity.address && opportunity.address.number"
          >
            {{ opportunity.address.number }}
          </span>
          
          <span
            class="opportunity-address-neighborhood"
            v-if="opportunity.address && opportunity.address.neighborhood"
          >
            - {{ opportunity.address.neighborhood.toLowerCase() }}
          </span>
        </h3>     
      </div>

      <div
        class="opportunity-responsability-container"
        v-if="opportunity.responsability"
        v-html="opportunity.responsability"
      ></div>

      <div class="opportunity-buttons-container">
        <slot name="know-more" class="opportunity-know-more-slot-button" />
        
        <slot name="shareComponent" class="opportunity-share-slot" />

        <b-btn
          @click="!showModalKnowMoreButton ? descriptionPage() : ''"
          v-b-modal="'modal' + opportunity.id"
          variant="transparent"
          class="opportunity-know-more-button"
          :disabled="subscriptionStep == 'applied' "
        >
          {{ subscriptionStep == 'applied' ? "Você já está inscrito" : knowMoreText || "Saiba mais" }}
        </b-btn>

        <a
          v-if="subscriptionStep == 'lead'"
          :href="redirectSubscription"
          class="opportunity-subscription-button btn-continue-subscription"
        >
          Continuar Inscrição
        </a>

        <a
          v-else
          :href="redirectSubscription"
          class="opportunity-subscription-button"
          :class="[ subscriptionStep == 'applied' ? 'subscription-btn-enrolled' : 'subscription-btn-not-enrolled', ]"
        >
          {{ subscriptionStep == 'applied' ? "Você já está inscrito" : btnSubscriptionText || "QUERO ME INSCREVER!" }}
        </a>
      </div>

      <p class="opportunity-expire-date">
        Expira em {{ timeLeft.days }} {{ timeLeft.days == 1 ? "dia" : "dias" }}
        <span class="days" :style="{ width: timeLeft.percentage + '%' }"></span>
      </p>

      <ModalJobBox
        class="modal-job-box-wrapper"
        :opportunity="opportunity"
        :btnSubscriptionText="btnSubscriptionText"
        :customSubscriptionPageRoute="customSubscriptionPageRoute"
      >
        <div slot="fullColor">
          <slot name="fullColor" />
        </div>
      </ModalJobBox>
    </div>
  </div>
</template>

<script>
import WheelchairAccessibilityIcon from "vue-material-design-icons/WheelchairAccessibility.vue";
import ModalJobBox from "./ModalJobBox.vue";

export default {
  name: "JobBox",
  props: {
    opportunity: Object,
    id: Number,
    btnSubscriptionText: String,
    showModalKnowMoreButton: Boolean,
    showDescriptionPage: Boolean,
    knowMoreText: String,
    customSubscriptionPageRoute: String,
    showDescriptionPageOnCardClick: Boolean,
  },

  computed: {
    title() {
      return this.$helpers.toTitle(this.opportunity.title);
    },

    subscriptionStep() {
      const id = this.opportunity.id;
      const findSubscription = this.$store.state.opportunities.subscriptions.find(
        (subs) => subs.opportunityId == id
      );

      if (findSubscription) {
        return findSubscription.step;
      }

      return '';
    },

    enrolled() {
      const uri = this.opportunity.links.subscription.split("/");
      const name = uri[uri.length - 1];
      const id = name.match(/\d+/)[0];
      return !!this.$store.state.opportunities.subscriptions.find(
        (subs) => subs.opportunityId == id
      );
    },

    timeLeft() {
      const now = this.$moment();
      const published_at = this.$moment(this.opportunity.published_at).startOf(
        "day"
      );
      const expired_at = this.$moment(this.opportunity.expired_at).endOf("day");
      const total_days = expired_at.diff(published_at, "days");
      const time_left = expired_at.diff(now, "days");
      const percent = 100 - (100 * time_left) / total_days;
      return {
        percentage: percent > 100 ? 100 : percent,
        days: time_left < 0 ? 0 : time_left,
      };
    },

    redirectSubscription() {
      if(this.subscriptionStep == 'applied'){
        return '#'
      }
      
      if (this.opportunity.ninenine_apply === true) {
        if (process.env.VUE_APP_LOCAL_ENV !== 'production' ) {
          return `https://subscriptions.staging.99jobs.com/${this.opportunity.id}?callbackOriginUrl=${window.location.href}`;
        }

        return `https://subscriptions.99jobs.com/${this.opportunity.id}?callbackOriginUrl=${window.location.href}`;
      }

      return this.customSubscriptionPageRoute ? this.customSubscriptionPageRoute : '/vagas/' + this.opportunity.slug + '/inscricao';
    }
  },

  components: {
    WheelchairAccessibilityIcon,
    ModalJobBox,
  },

  methods: {
    descriptionPage() {
      this.$router.push({ name: "job", params: { id: this.opportunity.slug } });
    },
    hideModal(ref) {
      this.$refs[ref].hide();
    },
  },
};
</script>

<style lang="scss">
.job-box {
  & > * {
    display: none;
  }

  .opportunity-subscription-button.btn-continue-subscription{
    background-color: #3FCB2A;
    &:hover{
      background-color: #37bd22;
    }
  }
}
</style>
